import { Routes } from '@angular/router'

export const ROUTES: Routes = [
  {
    path: 'admin',
    loadChildren: './+admin#AdminModule'
  },
  {
    path: '',
    loadChildren: './+employer#EmployerModule'
  }
]